module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [((_vm.inputType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: _vm.classes,
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "name": _vm.name,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.inputType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: _vm.classes,
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "name": _vm.name,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      },
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: _vm.classes,
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "name": _vm.name,
      "type": _vm.inputType
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }, function($event) {
        _vm.$emit('input', $event.target.value)
      }]
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "position": "absolute",
      "top": "50%",
      "right": "15px",
      "transform": "translateY(-40%)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.togglePassword($event)
      }
    }
  }, [_c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputType === 'password'),
      expression: "inputType === 'password'"
    }],
    style: (_vm.iconStyle),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M.2 10a11 11 0 0 1 19.6 0A11 11 0 0 1 .2 10zm9.8 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
    }
  })]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputType !== 'password'),
      expression: "inputType !== 'password'"
    }],
    style: (_vm.iconStyle),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.81 4.36l-1.77 1.78a4 4 0 0 0-4.9 4.9l-2.76 2.75C2.06 12.79.96 11.49.2 10a11 11 0 0 1 12.6-5.64zm3.8 1.85c1.33 1 2.43 2.3 3.2 3.79a11 11 0 0 1-12.62 5.64l1.77-1.78a4 4 0 0 0 4.9-4.9l2.76-2.75zm-.25-3.99l1.42 1.42L3.64 17.78l-1.42-1.42L16.36 2.22z"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.verified),
      expression: "!verified"
    }],
    class: _vm.errorClasses,
    staticStyle: {
      "margin-top": ".5rem",
      "color": "red"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.failedValidationMessage) + "\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca0b9800"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/password-input/VueInputPassword.vue
// module id = 1451
// module chunks = 0